<template>
  	<div id="ploydetail">
  		<mt-header fixed :title="title">
          <mt-button icon="back" slot="left" onclick="window.history.go(-1)"></mt-button>
        </mt-header>
        <div class="header">
			<img src="../../assets/img/coinDetail/bg_bizhongxiangqing.png" alt="" class="bg">
			<p class="amount wx_fontSize5">
				{{$t('wealth.annu_return')}} + {{packagedetail.annualized_returns}}%
			</p>
			<p class="asset wx_fontSize4">{{total | numFilter}} {{coin_symbol}}</p>
			<!-- <p class="address wx_fontSize2">
				{{currency_char}} {{total_usdt | numFilter}}
			</p> -->
			<div class="footer">
				<div class="item" @click="huoqi()">
					<div class="detail">
						<p>{{$t('wealth.ystday_earnings')}}</p>	
						<p class="synum">{{yesterday_revenue | numFilter}} {{coin_symbol}}</p>	
					</div>
				</div>
				<div class="line"></div>
				<div class="item right">
					<div class="detail">
						<span>{{$t('wealth.total_earnings')}}</span>	
						<p class="synum">{{revenue | numFilter}} {{coin_symbol}}</p>	
					</div>
				</div>
			</div>
		</div>

		<div class="content">
			<ul class="content_detail">
                <li v-for="val in log">
                    <div class="x">
						<div class="box">
							<div class="img"><img v-bind:src="val.coin_icon" /></div>
							<div class="texts" :class="{nobtn:val.status == 2}">
								<div class="t-line">
									<div >
										{{$t('wealth.transfer_in')}}
										<span v-if="val.status == 2" style="color: #ff6600;">( {{$t('wealth.transfer_outed')}} )</span>
									</div>
									<div class="">{{val.ctime}} - {{val.end_time}}</div>
								</div>
								<div class="t-line">
									<div>{{val.name}}</div>
									<!-- <div style="font-weight: bold;">{{(val.amount)}}</div> -->
									<div style="font-weight: bold;" v-if="val.is_prebuy_nasdaq == 0">{{(val.amount)}}</div>
									<div style="font-weight: bold;" v-if="val.is_prebuy_nasdaq == 1">{{(val.amount * 0.9)}} 
										<span v-if="val.wealth_pid == 9 || val.wealth_pid == 10 || val.wealth_pid == 11">(2UT)</span>
										<span v-if="val.wealth_pid == 12 || val.wealth_pid == 13 || val.wealth_pid == 14">(U2U)</span>
									</div>
									<div style="font-weight: bold;" v-if="val.is_prebuy_nasdaq == 3">{{(val.amount * 0.7)}} 
										<span v-if="val.wealth_pid == 9 || val.wealth_pid == 10 || val.wealth_pid == 11">(2UT)</span>
										<span v-if="val.wealth_pid == 12 || val.wealth_pid == 13 || val.wealth_pid == 14">(U2U)</span>
									</div>
								</div>
								<!-- <div v-if="val.status == 1" class="t-line">
									<div>{{$t('nasdaq.label')}}</div>
									<div>
										<span v-if="val.is_prebuy_nasdaq == 0" class="btn" @click="handlePreBuyNasdaq(val)">{{$t('nasdaq.apply')}}</span>
										<span v-else style="color: #ff6600;">{{$t('nasdaq.applyed')}}</span>
									</div>
								</div> -->
								<div v-if="val.is_prebuy_nasdaq > 0" class="t-line">
									<div>{{$t('nasdaq.label2')}} 
										<span v-if="val.wealth_pid == 9 || val.wealth_pid == 10 || val.wealth_pid == 11">(2UT)</span>
										<span v-if="val.wealth_pid == 12 || val.wealth_pid == 13 || val.wealth_pid == 14">(U2U)</span>
									</div>
									<div style="font-weight: bold;" v-if="val.is_prebuy_nasdaq == 1">{{val.amount * 0.1}} 
										<span v-if="val.wealth_pid == 9 || val.wealth_pid == 10 || val.wealth_pid == 11">(2UT)</span>
										<span v-if="val.wealth_pid == 12 || val.wealth_pid == 13 || val.wealth_pid == 14">(U2U)</span>
									</div>
									<div style="font-weight: bold;" v-if="val.is_prebuy_nasdaq == 3">{{val.amount * 0.3}} 
										<span v-if="val.wealth_pid == 9 || val.wealth_pid == 10 || val.wealth_pid == 11">(2UT)</span>
										<span v-if="val.wealth_pid == 12 || val.wealth_pid == 13 || val.wealth_pid == 14">(U2U)</span>
									</div>
								</div>
							</div>
						</div>
						<!-- <div v-if="val.status == 1" class="r">
							<span @click="sellploy(val)">{{$t('wealth.transfer_out')}}</span>
						</div> -->
					</div>
				</li>
			</ul>
		</div>
		<div class="caozuo" v-if="packagedetail && packagedetail.status == 1">
			<!-- <div class="huachu"  @click="sellploy()">{{$t('wealth.transfer_out')}}</div> -->
			<div class="huaru"  @click="buyploy()">{{$t('wealth.transfer_in')}}</div>
		</div>
		<div v-if="showPopup" class="popup">
			<div class="popup-box">
				<div class="popup-head">
					{{$t('nasdaq.background')}}
				</div>
				<div class="popup-body">
					{{$t('nasdaq.text')}}
				</div>
				<div class="popup-btns">
					<div class="cancel" @click="showPopup = false">{{$t('nasdaq.cancel')}}</div>
					<div class="submit" @click="submitBuynasdaq()">{{$t('nasdaq.submit')}}</div>
				</div>
			</div>
		</div>
  	</div>
</template>

<script>
	import { Toast, MessageBox } from 'mint-ui';
	import { httpGetMywealth, httpGetMywealthNew,httpGetOrders,httpGetAdvanceOrder, httpPostBuyNasdaq } from "@/api/wealth";
	export default {
		data:function() {  
		    return {  
	    		detail:{},
				packagedetail: {},
	    		log:{},
	    		title:'',
	    		coin_symbol:'',
                currency:'',
                currency_char:'',
                currency_usd_rate:'',
	    		id:0,
				total: 0,
				total_usdt: 0,
				revenue: 0,
				yesterday_revenue: 0,
				showPopup: false,
				active: {}
		    }  
	    }, 
	    activated(){
            this.currency = this.$store.state.currency,
            this.currency_char = this.$store.state.currency_char,
            this.currency_usd_rate = this.$store.state.currency_usd_rate,
	    	this.coin_symbol = this.$route.query.coin_symbol;
	    	// this.title = this.$route.query.title;
	    	this.id = this.$route.query.id;
			this.getDetial();
			this.getLog();
	    },
        filters: {
            numFilter(value) {
                let transformVal = Number(value).toFixed(6);
                let realVal = transformVal.substring(0, transformVal.length);
                return Number(realVal);
            }
        },
	    methods:{
			handlePreBuyNasdaq(val){
				console.log('val', val);
				this.active = val
				this.showPopup = true
			},
			submitBuynasdaq(){
				httpPostBuyNasdaq({
					id: this.active.id
				})
				.then(res => {
					this.showPopup = false
					Toast(this.$t('ok'));
					this.getLog();
				})
				.catch(() => {});
			},
			getDetial: function() {
				let currency = this.$store.getters.currency ? this.$store.getters.currency : 'USDT';
				httpGetMywealthNew({
					id: this.id,
					currency: currency
				})
				.then(res => {
					this.detail = res.data.list[0];
					
					this.total = res.data.total;
					this.total_usdt = res.data.total_usdt;
					this.revenue = res.data.revenue
					this.yesterday_revenue = res.data.yesterday_revenue
					
				})
				.catch(() => {});
				// httpGetMywealth({id:this.id})
				// .then(res => {
				// 	this.detail = res.data.list[0];
				// 	this.total = res.data.total;
				// })
				// .catch(() => {});
			},
			getLog: function() {
				httpGetOrders({wealth_pid:this.id})
				.then(res => {
					this.log = res.data.list;
					this.packagedetail = res.data.detail;
					this.title = this.packagedetail.name
				})
				.catch(() => {});
			},
			buyploy(){
            	this.$router.push({path:"/buyploy",query:{id:this.id,title:this.title,coin_symbol:this.detail.coin_symbol}})
            },
			sellploy(val){
				MessageBox({
					title: this.$t('wealth.mbox_title'),
					message: this.$t('wealth.mbox_msg_unexpired'),
					showCancelButton: true,
					cancelButtonText: this.$t('alert.cancel'),
					confirmButtonText: this.$t('alert.confirm'),
				}).then(action => {
				  if(action === 'confirm'){
					  httpGetAdvanceOrder({id:val.id})
					  .then(res => {
						  Toast(this.$t('ok'));
						  this.getLog();
					  })
					  .catch(() => {});
				  }
				});
				return false;
            	//this.$router.push({path:"/sellploy",query:{id:this.id,title:this.title,coin_symbol:this.detail.coin_symbol}})
            },
            against(){
            	this.$router.push('/against')
            },
            ploydetail(id,title){
            	this.$router.push({path:"/plandetail",query:{id:id,title:title}})
            },
            receive(){
            	this.$router.push('/receive')
            }
		}
	}
</script>
<style lang="less" scoped>
	.popup{
		position: fixed;
		width: 100%;
		height: 100%;
		z-index: 999999;
		background-color: rgba(0,0,0,0.15);
		display: flex;
		align-items: center;
		justify-content: center;
		left: 0;
		top: 0;
		.popup-box{
			width: 92%;
			min-height: 100px;
			background-color: #ffffff;
			border-radius: 12px;
			box-shadow: 0 0 24px rgba(0,0,0,0.15);
			.popup-head{
				padding: 12px 0;
				text-align: center;
				border-bottom: 1px solid #f0f0f0;
			}
			.popup-body{
				padding: 12px;
				font-size: 14px;
				line-height: 180%;
			}
			.popup-btns{
				padding: 12px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-top: 1px solid #f4f4f4;
				.cancel,
				.submit{
					width: calc(50% - 12px);
					text-align: center;
					padding: 6px 0;
				}
				.submit{
					color: #0191f5;
				}
			}
		}
	}
#ploydetail{width:100%;height:100%;overflow: hidden;position: fixed;background:#f6f6f6;}
.mint-header{background: transparent;}
.header{width:100%;height:234px;position: relative;text-align: center;}
.header .bg{width:100%;height:100%;}
.amount{position:absolute;top:80px;color:#fff;font-size: 0.875rem;}
.asset{
	color: #fff;
    position: absolute;
    top: 100px;
    font-size: 2rem;
}
.add{width:54px;height:54px;position: absolute;right: 15px;top:60px;}
.address{
    position: absolute;
    top: 146px;
    color: #fff;
}
.address img{width:13px;height:13px;margin-left: 10px;}
.select{position: absolute;bottom:0;height:56px;width:100%;background:rgba(225,225,225,0.15);color:#fff;}
.select li{width:calc((100% / 3) - 4px);height: 30px;margin-top: 13px;border-right: 2px solid rgba(225,225,225,0.3);float: left;text-align: center;line-height: 30px;}
.select li img{width:19px;height: 19px;margin-left: -6px;position: relative;top:4px;}
.select li span{margin-left:12px;}
/*内容*/
.content{
    background: #f6f6f6;
    width: 100%;
    padding-bottom: 65px;
    height: calc(100% - 234px);
    overflow: scroll;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.local{padding-top:0;}
.content_detail{padding:10px 0 0 0;}
.content_detail li{padding: 6px 12px;}
.oImg{
    width: 34px;
    height: 34px;
    margin: 15px 10px 5px 14px;
}
.currency_name{
	position: relative;
    top: -20px;
    font-size: 0.875rem;
    font-weight: bold;
}
.amount_of{
    width: 44%;
    text-align: right;
    padding: 0 15px 0 0;
}
.count{color:#0191f5;padding:22px 0 10px 0;font-weight: bold;}
.count.red{
	color: #ff9900;
}
.money{color:#8c92a8;}

.block_list{width:100%; display: none;}
.block_list img{margin-top: 62px;width:264px;margin-left: calc(50% - 132px);}
.tip{color:#8c92a8;width:100%;text-align: center;position: relative;top:-40px;}
p{
	width: 100%;
}

.left_lable{
    font-size: 0.75rem;
    margin: 0 0 0 58px;
    float: left;
    color: #a9afc8;
    line-height: 16px;
    position: absolute;
    bottom: 15px;
}
.right_lable{
	font-size: 0.75rem;
    color: #8c92a8;
    position: absolute;
    bottom: 15px;
    right: 15px;
}
.clear{
	clear: both;
}
.line{
    width: 0;
    height: 30px;
    border-right: 2px solid #5ba1ff;
    position: absolute;
    left: 50%;
    z-index: 1;
    top: 22px;
}

.footer{
	width:100%;height:75px;
	position: absolute;
    bottom: 0;
}
.footer .item{
    width: 50%;
    height: 100%;
    font-size: 0.75rem;
    color: #fff;
    text-align: center;
    position: absolute;
    top: 0;
}
.synum{
	font-size: 0.875rem;
	line-height: 20px;
}
.footer .item .detail{
    height: 38px;
    position: absolute;
    top: 19px;
    width: 150px;
    left: 50%;
    margin: 0 0 0 -50px;
}
.footer .item.right{
    right: 0;
}
.footer .item img{
    width: 38px;
    display: block;
    position: absolute;
}
.caozuo{
	width: 100%;
	height: 50px;
	position: fixed;
	bottom: 0;
	text-align: center;
	.huachu{
		height: 100%;
		width: 50%;
		line-height:50px;
		font-size: 1.125rem;
		color: #1296db;
		background-color: #b2d4fc;
		position: absolute;
		left: 0;
	}
	.huaru{
		height: 100%;
		width: 100%;
		line-height:50px;
		font-size: 1.125rem;
		color: #fff;
		background-color: #1296db;
		position: absolute;
		right: 0;
	}
}
.x{
	padding: 0;
	.box{
		display: flex;
		align-items: center;
		justify-content: space-between;	
		background:#fff;
		border-radius: 6px;
		padding: 6px 10px;
		box-shadow: 0 0 24px rgba(0,0,0,0.05);
		.img{
			width: 48px;
			img{
				width: 48px;
			}
		}
		.texts{
			width: calc(100% - 64px);
			.t-line{
				display: flex;
				align-items: center;
				justify-content: space-between;	
				font-size: 14px;
				font-weight: normal;
				padding: 4px 0;
				.btn{
					padding: 4px 10px;
					color: #ffffff;
					background-color: #0191f5;
					border-radius: 4px;
				}
			}
		}
	}
}
.status{
	font-size: 0.75rem;
	font-weight: 100;
	top: -20px;
	position: relative;
	margin-left: 4px;
	background-color: #8c92a8;
	color: #f6f6f6;
	position: absolute;
	right: 1px;
	top: 1px;
	padding: 2px 6px;
	border-radius: 4px;
}
</style>